import type { PipeTransform } from '@angular/core';
import { Injectable, Pipe } from '@angular/core';
import type { SafeHtml } from '@angular/platform-browser';
import { DomSanitizer } from '@angular/platform-browser';

type argsT = {
  a?: string;
  a1?: string;
  a2?: string;
};

@Pipe({ name: 'rtiUrlInTranslations', standalone: true })
@Injectable({ providedIn: 'root' })
export class UrlInTranslationsPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  public transform(translation: string, args: argsT): SafeHtml {
    const t = Object.keys(args).reduce(
      (acc, a: keyof argsT) => acc.replace(`</${a}>`, '</a>').replace(`<${a}>`, `<a ${args[a]}>`),
      translation,
    );
    // eslint-disable-next-line ban/ban
    return this.sanitizer.bypassSecurityTrustHtml(t);
  }
}
